import { dom, model as router, type History, type Route } from '!/router'
import { noop } from '@/helpers'
import { createEvent, sample, type EventCallable } from 'effector'
import { landingRegionFeatureModel } from '~/features/landingRegion'
import { session } from '~/features/session'
import { analytix, launch, navigation, seoTracking } from '~/processes'

// init application
export const init: EventCallable<{
  history: History
  container: HTMLElement
  routes: Route
}> = createEvent()

// init application launch process
sample({
  clock: init,
  fn: noop,
  target: launch.init,
})

sample({
  clock: launch.appCanBeLaunched,
  target: seoTracking.init,
})

// init router model at application init
sample({
  clock: init,
  fn: ({ history, routes }) => ({ history, routes }),
  target: router.init,
})

// init dom model at application init
sample({
  clock: init,
  fn: ({ container }) => ({ container }),
  target: dom.init,
})

// init application navigation process
sample({
  clock: launch.appCanBeLaunched,
  fn: noop,
  target: navigation.init,
})

// init application session process
sample({
  clock: launch.appCanBeLaunched,
  fn: noop,
  target: session.init,
})

sample({
  clock: launch.appCanBeLaunched,
  fn: noop,
  target: landingRegionFeatureModel.init,
})

// init analytics process
sample({
  clock: init,
  fn: noop,
  target: analytix.init,
})

//
// handlers for external usages
//

export const onLocationChange = navigation.renderFx.use
